module.exports = __webpack_public_path__ + "img/ic_file-blurry.fa5e9021.svg";